import { useTranslation } from 'react-i18next';
import { Button, Link, Stack, Typography } from '@mui/material';
import { StepBox } from '@/components/layout/step-box';
import { Flow } from '@/constants/flow';
import { useBizState } from '@/hooks/use-biz-state';
import { useDisplayAccount } from '@/hooks/use-display-account';
import { useFlow } from '@/hooks/use-flow';

export const StepChooseAccount: React.FC = () => {
  const { setFlow } = useFlow();
  const { t } = useTranslation();
  const { callBack } = useBizState();
  const { displayAccount } = useDisplayAccount();

  const handleChange = () => {
    setFlow(Flow.LOGIN_STEP_INPUT_USERNAME, {
      resetBiz: true,
    });
  };

  const handleContinue = () => {
    if (callBack) window.location.href = callBack;
  };

  return (
    <StepBox title={t('account_selection_title')}>
      <Stack spacing={2}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
          <Typography variant="body1" className="truncate" title={displayAccount}>
            {displayAccount}
          </Typography>
          <Link variant="body2" component="button" onClick={handleChange} underline="always">
            {t('change')}
          </Link>
        </Stack>
        <Button variant="contained" onClick={handleContinue}>
          {t('continue')}
        </Button>
      </Stack>
    </StepBox>
  );
};
